/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    Container,
    Typography,
    Alert,
    Grid
} from '@mui/material';
import OTPServices from '../services/otp/index'
import AuthServices from '../services/auth';
import OTPCard from '../components/otp/index'
import localAuthServices from '../localAuthServices';

const EmailOTP = () => {
    const navigate = useNavigate();
    const [alertType, setAlertState] = useState('');
    const [apiMessage, setMessageState] = useState('');
    const [verifyEmailState, setVerifyEmailState] = useState();
    const [emailVerified, setEmailVerified] = useState();
    const [values, setValues] = useState();

    var query = window.location.search.substring(1);
    var vars = query.split("&");
    var pair1 = vars[0].split("=");
    const [sourceDomain] = useState(pair1[1]);

    const handler = () => {
        setEmailVerified(true);
        setVerifyEmailState(false);
    }

    useEffect(() => {
        localAuthServices.refreshTokenOnLoad()
    }, [])

    return (
        <>
            <Grid
                container
                spacing={0}
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh' }}
            >
                <Grid item xs={12} md={6} className='logoContainer'
                    textAlign="center">
                    <img src='/logo_black.png' alt="iCapital" className='logo' />
                </Grid>
                {!verifyEmailState ?
                    <Grid item xs={11} md={6} className='displayBoxBorder'>
                        <Box style={{ width: 'auto' }}>
                            {apiMessage != '' &&
                                <Box mb={3}>
                                    <Alert severity={alertType}>
                                        {apiMessage}
                                    </Alert>
                                </Box>
                            }
                            <Box mb={4}>
                                <Typography
                                    color="primary"
                                    variant="h5"
                                    align="center"
                                >
                                    <b>Verify Email Address</b>
                                </Typography>
                            </Box>
                            <Typography color="textSecondary" gutterBottom>
                                <Box>{'Click the button below to receive an OTP on your registered email address. Enter your OTP in the next screen to complete your email verification.'}</Box>
                            </Typography>
                            <Typography align='center'>
                                <Button
                                    onClick={() => {
                                        AuthServices.getUserData({}, apiData => {
                                            if (apiData.status) {
                                                setValues(apiData.data)
                                                OTPServices.generateRegisterOTP({
                                                    'email': apiData.data.email,
                                                    'service': 2
                                                });
                                                setVerifyEmailState(true)
                                            }
                                        })
                                    }}
                                >
                                    {'Get OTP'}
                                </Button>
                            </Typography>
                        </Box>
                    </Grid>
                    :
                    <Grid item xs={12} md={6}>
                        <Container maxWidth="md">
                            <OTPCard
                                apiEndpoint="profile_email"
                                navigator={navigate}
                                handler={handler}
                                details={{
                                    email_address: values.email,
                                }}
                                sourceDomain={sourceDomain}
                            />
                        </Container>
                    </Grid>
                }
            </Grid>
        </>
    );
};

export default EmailOTP;